import { combineReducers } from "redux";
import accountManagementReducer from "./accountManagementSlice";
import centreonReducer from "./centreonSlice";
import creditLimitManagementReducer from "./creditLimitManagementReducer";
import dashboardSlice from "./dashboardSlice";
import logManagementReducer from "./logsManagement/logManagementSlice";
import networkManagementSlice from "./networkManagementSlice";
import notificationSlice from "./notificationSlice";
import projectOverviewReducer from "./projectoverviewSlice";
import provManagementReducer from "./provManagement/provManagementSlice";
import sidebarReducer from "./sidebarSlice";
import stockSlice from "./stockSlice";
import VesselsReducer from "./vesselsSlice";

const rootReducer = combineReducers({
	sidebar: sidebarReducer,
	vessels: VesselsReducer,
	stock: stockSlice,
	projectOverview: projectOverviewReducer,
	dashboard: dashboardSlice,
	accountManagement: accountManagementReducer,
	provManagement: provManagementReducer,
	networkManagement: networkManagementSlice,
	centreon: centreonReducer,
	logManagement: logManagementReducer,
	notifications: notificationSlice,
	creditLimitManagement: creditLimitManagementReducer,
});

export default rootReducer;
